import { TextValue } from "../../tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "PortfolioFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    portfolio_name: String,
    portfolio_id_list: Array,
    portfolio_id: String,
    selected: Boolean,
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue
  }
};